function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  padding: 0 0.75rem;\n  white-space: nowrap;\n  text-align: left;\n  line-height: ", ";\n  border-bottom-style: solid;\n  border-bottom-width: ", ";\n  border-bottom-color: ", ";\n  user-select: none;\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  text-transform: uppercase;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: ", ";\n  vertical-align: middle;\n  margin-left: 0.25rem;\n  transition: transform 0.2s;\n  transform: rotate(", ");\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from "../../../../../theme";

var WrappedDiv = function WrappedDiv(_ref) {
  var visible = _ref.visible,
      descending = _ref.descending,
      rest = _objectWithoutProperties(_ref, ["visible", "descending"]);

  return React.createElement('div', rest);
};

export var CellSortingIcon = styled(WrappedDiv)(_templateObject(), function (props) {
  return props.theme.variables.icons.size.small;
}, function (props) {
  return props.theme.variables.icons.size.small;
}, function (p) {
  return "url(\"".concat(p.theme.variables.icons.svg.chevronS, "\")");
}, function (props) {
  return props.descending ? '-180deg' : '0deg';
}, function (props) {
  return props.visible ? 'inline-block' : 'none';
});
export var CellText = styled.span(_templateObject2());
export var CellWrapper = styled.th(_templateObject3(), function (props) {
  return props.theme.variables.fonts.size.bigger2;
}, function (props) {
  return props.theme.variables.borders.width.base;
}, function (props) {
  return props.theme.variables.colors.platinum;
});